import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export type TagType = {
  type:
    | 'Stopover'
    | 'StopoverLog'
    | 'Vessel'
    | 'Company'
    | 'Manoeuvre'
    | 'Docking'
    | 'BreakdownOccurrence'
    | 'NcmItem'
    | 'OperationCalculus'
    | 'Compartments'
    | 'OperationCrane'
    | 'Charge'
    | 'User'
    | 'WarehousingInvoices'
    | 'Pumping'
    | 'VesselRequestUpdate'
    | 'OperationLine'
    | 'Line'
    | 'DockingPlace'
    | 'WarehousingImporting'
    | 'CargoSuppression'
    | 'WasteCollection';
  code?: string | number;
  // O RTK Query casa tag com tag por `type` e `id`. A chave `code` acima é
  // ignorada por ele, então toda invalidação que a usa vale pelo tipo inteiro.
  // Quem precisa de invalidação por chave usa `id`.
  id?: string | number;
};

// função criada para não invalidar tags caso dê erro na request
export function getInvalidatesTags(
  error: FetchBaseQueryError | undefined,
  tags: TagType[]
): TagType[] | [] {
  return error === undefined ? tags : [];
}

// função para limpar parâmetros de consulta, removendo valores undefined, null ou string vazia
export const cleanParams = <T extends Record<string, any>>(
  params: T
): Partial<T> => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
  ) as Partial<T>;
};
